/* eslint-disable no-unused-vars */
import { transColumnFixClassName } from './autoWidth'
import { handleColPresetType } from './columnPreset.js'

export const deepHandleColBeforeRender = (columns) => {
  // 利用了对象ref特性，深层次的函数修改对象，调用者这边也会更改
  const localColumns = columns
  if (!localColumns) {
    return []
  }

  localColumns.forEach(col => {
    // 这里仅仅处理最后一一层
    if (col.children) {
      deepHandleColBeforeRender(col.children)
    }

    // auto width 增加必要的className
    // transColumnFixClassName(col)
    // 处理预设的类型，添加col默认值
    handleColPresetType(col)
  })

  return localColumns
}
